<template>
  <div>
    <ContactStoreForm :watchRef="this.item.product.manufacturer_sku" @close="() => {$emit('close')}">
      <ProductMiniPreview :item="this.item" :picture="this.picture" />
    </ContactStoreForm>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ProductMiniPreview from './utils/ProductMiniPreview.vue'
import ContactStoreForm from './storeloc/ContactStoreForm.vue'

export default {
  name: 'PdpAppointmentform',
  props: ['item', 'picture'],
  mixins: [ReadyHook],
  components: {
    ContactStoreForm,
    ProductMiniPreview
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
</style>
